// <task-priority level='{{task.latestEvent.priority}}'></task-priority>
function taskPriority($translate, translateService) {
  function link($scope, element, attrs) {
    const scope = $scope;
    const priorities = {
      3: {
        title: 'High',
        priorityClass: 'twp-task-priority-high'
      },
      2: {
        title: 'Medium',
        priorityClass: 'twp-task-priority-medium'
      },
      1: {
        title: 'Low',
        priorityClass: 'twp-task-priority-low'
      }
    };

    translateService.keyArray(priorities, 'title', 'PRIORITY');

    attrs.$observe('level', (level) => {
      if (level > 0 && level < 4) {
        scope.priorityClass = priorities[level].priorityClass;
        scope.title = priorities[level].title;
      } else {
        scope.title = $translate.instant('PRIORITY_UNKNOWN');
      }
    });
  }

  return {
    link,
    restrict: 'E',
    scope: {},
    template: '<span class=\'{{priorityClass}}\'>{{ title }}</span>'
  };
}

const taskPriorityArray = [
  '$translate',
  'translateService',
  taskPriority
];

export default function (ngModule) {
  ngModule.directive('taskPriority', taskPriorityArray);
}
